var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.3418 31.6667H36.6752V35H3.3418V31.6667ZM3.3418 8.33337L11.6751 14.1667L20.0085 3.33337L28.3418 14.1667L36.6752 8.33337V28.3334H3.3418V8.33337ZM6.67513 14.7356V25H33.3418V14.7356L27.6427 18.7249L20.0085 8.80044L12.3742 18.7249L6.67513 14.7356Z",
    fill: "#E60A2B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignModalIcon);
export default __webpack_public_path__ + "static/media/assign-modal-icon.21eb7780060c0a9eadfdfdc848582035.svg";
export { ForwardRef as ReactComponent };